<template>
  <div>
    <Header></Header>
    <div class="background">
      <div class="read-details" v-for="(list,index) in lists" :key="index">
        <!-- 微导航  -->
        <div class="wnav">
          <span>主题阅读</span>
          <img src="../../assets/img/in.png" alt />
          <span class="gengduo">{{list.name}}</span>
        </div>
        <div class="body">
          <div class="left">
            <div class="lcont">
              <div class="title">{{list.name}}</div>
              <div class="name_time">
                <div>
                  <span>{{list.source}}</span>
                  <span>{{list.createtime}}</span>
                </div>
                <div @click="shareToQQ()">
                  <img src="../../assets/img/w_fx.png" alt /> 分享
                </div>
              </div>
              <div class="line"></div>
              <div class="cont" v-html="list.content">{{list.content}}</div>
            </div>
            <div class="btn">
              <div class="dz" v-if="dz_show==0" @click="dz(1)">为他点赞</div>
              <div class="yd" v-else>已点赞({{list.like_count}})</div>
            </div>
          </div>
          <div class="right">
            <div class="r-cont">
              <div class="related">相关推荐</div>
              <div
                class="list"
                @click="rdetails(list1)"
                v-for="(list1,index) in list.tuijian_array"
                :key="index"
              >
                <div>
                  <div class="name">{{list1.name}}</div>
                  <div class="lect">{{list1.source}}</div>
                </div>
                <div>
                  <img  class="img" :src="list1.image" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <Login v-show="popup==1"></Login>
  </div>
</template>

<script>
import Header from "../header";
import Footer from "../footer";
import Login from "../popup/login";
export default {
  data() {
    return {
      lists: [],
      dz_show: 0,
      id: "",
      uid: "",
      popup: ""
    };
  },
  created() {
    var id = this.$route.query.id;
    this.id = id;
    if (JSON.parse(sessionStorage.getItem("data"))) {
      this.uid = JSON.parse(sessionStorage.getItem("data")).id;
    }
  },
  methods: {
    // 相关推荐
    rdetails(list) {
      this.id = list.id;
      this.article_detail();
    },
    //分享到QQ好友(PC端可用)
    shareToQQ() {
      //此处分享链接内无法携带图片
      const share = {
        title: "知会教育",
        desc: "知会教育pc端QQ分享",
        share_url: window.location.href
      };
      location.replace(
        "https://connect.qq.com/widget/shareqq/index.html?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&desc=" +
          share.desc
      );
    },
    //   阅读详情
    async article_detail() {
      await this.$service.home
        .article_detail({ id: this.id, uid: this.uid })
        .then(res => {
          if (res.data.code == 200) {
            var arr = [];
            arr.push(res.data.content);
            this.lists = arr;
            this.dz_show = res.data.content.if_like;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 阅读点赞
    async dz(i) {
      if (JSON.parse(sessionStorage.getItem("data"))) {
        var id = JSON.parse(sessionStorage.getItem("data"));
        await this.$service.home
          .like_article({ id: this.id, uid: id.id, type: i })
          .then(res => {
            if (res.data.code == 200) {
              this.dz_show = 1;
              this.article_detail()
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.popup = 1;
      }
    }
  },
  components: {
    Header,
    Footer,
    Login
  },
  mounted() {
    this.article_detail();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.read-details {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}
.wnav {
  height: 30px;
  line-height: 40px;
  font-size: 14px;
  margin-bottom: 10px;
}
.wnav span.gengduo {
  color: rgba(136, 136, 136, 1);
}
.read-details .body {
  display: flex;
  justify-content: space-between;
}
/* 左边 */
.read-details .body .left {
  width: 860px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
}
.read-details .body .left .lcont {
  width: 820px;
  margin: 0 auto;
  margin-top: 26px;
}
.read-details .body .left .lcont .title {
  font-size: 22px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-bottom: 49px;
}
.read-details .body .left .lcont .name_time {
  font-size: 16px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 22px;
  margin-bottom: 21px;
  display: flex;
  justify-content: space-between;
}
.read-details .body .left .lcont .line {
  width: 820px;
  height: 1px;
  margin-bottom: 24px;
  background: rgba(216, 216, 216, 1);
}
.read-details .body .left .lcont .cont {
  font-size: 16px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 36px;
}
/* 右边 */
.read-details .body .right {
  width: 324px;
  height: 813px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
}
.read-details .body .right .r-cont {
  width: 282px;
  margin: 0 auto;
}
.read-details .body .right .r-cont .related {
  width: 280px;
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  border-left: 3px solid #1775ef;
  padding-left: 5px;
  margin: 0 auto;
  margin-bottom: 16px;
  margin-top: 20px;
}
.read-details .body .right .r-cont .list {
  border-bottom: 1px solid #ededed;
  height: 92px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}
.read-details .body .right .r-cont .list .img {
  width: 109px;
  height: 76px;
  border-radius: 6px;
}
.read-details .body .right .r-cont .list .name {
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 24px;
}
.read-details .body .right .r-cont .list .lect {
  font-size: 12px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 22px;
}
/* btn */
.read-details .btn {
  display: flex;
  justify-content: space-around;
  width: 860px;
  margin-bottom: 14px;
  /* position: absolute;
  bottom: 74px; */
}
.read-details .btn .dz {
  text-align: center;
  width: 340px;
  height: 46px;
  background: rgb(135, 184, 246);
  font-size: 18px;
  font-weight: 400;
  color: #108ee9;
  line-height: 46px;
}
.read-details .btn .yd {
  text-align: center;
  width: 340px;
  height: 46px;
  background: rgb(195, 192, 192);
  font-size: 18px;
  font-weight: 400;
  color: rgba(136, 136, 136, 1);
  line-height: 46px;
}
</style>



// WEBPACK FOOTER //
// src/components/reading/read_details.vue